import type { ReactNode } from 'react';
import { classNames } from '../../utils';

export type ControlButtonProps = {
  title: string;
  /** Suffix of the class `cm-controls-<name>`. */
  name: string;
  onClick: () => void;
  disabled?: boolean;
  children: ReactNode;
};

/** One square button of the Controls panel. */
export const ControlButton = ({ title, name, onClick, disabled = false, children }: ControlButtonProps) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    disabled={disabled}
    onClick={onClick}
    className={classNames('cm-controls-button', `cm-controls-${name}`)}
  >
    {children}
  </button>
);
